import { Box } from "@mui/material";

import { usePclContext } from "../../context/PclContextProvider";

import MaintenanceCard from "./MaintenanceCard";
import ProductCard from "./ProductCard";

export default function ProductGridView() {
  const { products } = usePclContext();

  return (
    <Box display="flex" flexWrap="wrap">
      {products?.map((card) => {
        if (!card) return;

        return (
          <Box key={card.product_id} flex="1 1 calc(50% - 2em)" margin="1em">
            {card?.active_maintenances?.length === 0 ? (
              <ProductCard card={card} />
            ) : (
              <MaintenanceCard card={card} />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
